import React from 'react';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import IconButton from '../../../../Button/IconButton';
import Title from '../../../../Popup/_partials/DialogCardLayout/Title';
import BasicUserAvatar from '../../../../User/_partials/BasicUserAvatar';
import s from './SelectedGroupHeader.scss';
const SelectedGroupHeader = ({ group, resetSelectedGroup })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(IconButton, {
        className: s['icon-button'],
        onClick: resetSelectedGroup
    }, /*#__PURE__*/ React.createElement(ArrowLeft, null)), /*#__PURE__*/ React.createElement(BasicUserAvatar, {
        className: s['avatar'],
        user: group,
        size: 28
    }), /*#__PURE__*/ React.createElement(Title, {
        value: group.username,
        isConcise: true
    }));
};
SelectedGroupHeader.displayName = 'SelectedGroupHeader';
export default SelectedGroupHeader;

//# sourceMappingURL=SelectedGroupHeader.js.map